import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';
import { ContinuousColorLegend } from '@mui/x-charts';

const CatlogModal = ({ isOpen, setIsOpen, data, setData, isEdit = false, fetchCategories }) => {
    const [brandName, setBrandName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [parentBrand, setParentBrand] = useState(null);
    const [image, setImage] = useState(null);
    const [pdf, setPdf] = useState(null)
    const [images, setImages] = useState([]);
    const [customer_no, setCustomerNo] = useState('');
    const [customer_email, setCustomerEmail] = useState('')
    const [description, setDescription] = useState('')
    const [showImageModal, setShowImageModal] = useState(false);
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const urlmain = process.env.REACT_APP_LINK
    const urlmain1 = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""
    const [selectType, setSelectType] = useState("image"); // image | pdf
    const [catnew, setCat] = useState([]);
    const [load, setLoad] = useState(false);
    // Fetch images from media library
    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${userDetails.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    // Dummy category data
    const [categories, setCategories] = useState([]);

    const fetchBrand = async () => {
        const res = await fetch(`${urlmain}/catlog-category`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setCategories(data);
    };

    /* ---------------- OPTIONS ---------------- */
    const parentBrandOptions = [
        { value: "", label: "Select" },
        ...categories.map(cat => ({
            value: cat.id,
            label: cat.name
        }))
    ];
    // const parentBrandOptions = [{ value: "", label: "None (Top-level)" }, ...brandOptions];
    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    // const handleImageSelect = (img) => {
    //     const selectedUrl = `${urlmain1}${img.url}`;
    //     setImage(selectedUrl);
    //     setShowImageModal(false);
    // };

    // const handlePdfSelect = (img) => {
    //     const selectedUrl = `${urlmain1}${img.url}`;
    //     setPdf(selectedUrl);
    //     setShowImageModal(false);
    // };

    const handleSelect = (file) => {
        const selectedUrl = `${urlmain1}${file.url}`;

        if (selectType === "image") {
            setImage(selectedUrl);
        } else {
            setPdf(selectedUrl);
        }

        setShowImageModal(false);
    };
    console.log(data)

    // const fetchCategories = async () => {

    //     try {
    //         const response = await fetch(`${urlmain}/catlog-category`, {
    //             method: "GET",
    //             headers: {
    //                 "Authorization": `Bearer ${token}`
    //             }
    //             // credentials: "include"
    //         })
    //         const res = await response.json();
    //         setCat(res);
    //     } catch (error) {
    //         console.error(error)
    //     } finally {

    //     }
    // }


    // Prefill form when editing
    useEffect(() => {
        if (isEdit && data) {
            setBrandName(data.name || '');
            setPosition(data.position || '');
            setStatus(statusOptions.find(s => s.value === data.status) || null);
            setParentBrand(parentBrandOptions.find(p => p.value === data.category_id) || null);
            setImage(data.image || null);
            setPdf(data.pdf || null)
            setCustomerEmail(data.customer_email);
            setCustomerNo(data.customer_no);
            setDescription(data.description)
        } else {
            setBrandName('');
            setPosition('');
            setStatus(null);
            setParentBrand(null);
            setImage(null);
        }
    }, [isEdit, data]);

    useEffect(() => {
        fetchImages();
        fetchBrand();
    }, []);

    if (!isOpen) return null;

    // Submit handler (create or update)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (load) return;
        if (!brandName) {
            toast.error("Please fill required fields");
            return;
        }
        const payload = {
            name: brandName,
            position,
            // status: status.value,
            image: image,
            pdf: pdf,
            category_id: parentBrand?.value || null,
            main_id: userDetails.main_id,

        };
        setLoad(true);

        try {
            const endpoint = isEdit
                ? `${urlmain}/catlog/${data.id}`
                : `${urlmain}/catlog`;

            const method = isEdit ? 'PUT' : 'POST';

            const res = await fetch(endpoint, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`

                },
                body: JSON.stringify(payload),
            });

            const result = await res.json();
            if (!res.ok) {
                toast.error(`${result.message}`)
            } else {


                toast.success(isEdit ? "Brand updated successfully!" : "Brand added successfully!");
                setIsOpen(false);
                fetchCategories();
                // setData(prev => isEdit
                //     ? prev.map(item => item.id === data.id ? result : item)
                //     : [...prev, result]
                // );
            }
        } catch (error) {
            console.error(error);
            toast.error("Error saving brand");
        } finally {
            setLoad(false);
        }
    };

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-content">
                <h2 className="oms-modal-title">{isEdit ? "Edit Catlog" : "Add Catlog"}</h2>
                <form className="oms-modal-form"  onSubmit={!load ? handleSubmit : undefined}>

                    {/* Brand Name */}
                    <div className="oms-form-group">
                        <label htmlFor="brandName" className="oms-form-label"> Heading</label>
                        <input
                            type="text"
                            id="brandName"
                            value={brandName}
                            onChange={(e) => setBrandName(e.target.value)}
                            placeholder="Enter Heading"
                        />
                    </div>


                    {/* Image */}
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="image" className="oms-form-label">Logo</label>
                    </div>

                    <button type="button" onClick={() => {
                        setSelectType("image");
                        setShowImageModal(true);
                    }}>
                        Select Image
                    </button>
                    {image && <img src={image} alt="Selected" style={{ width: 80, marginTop: 10 }} />}





                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="pdf" className="oms-form-label">Pdf</label>
                        <button type="button" onClick={() => {
                            setSelectType("pdf");
                            setShowImageModal(true);
                        }}>
                            Select Pdf
                        </button>
                        {pdf && <a href={pdf} target="_blank">View PDF</a>}

                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="parentBrand" className="oms-form-label">Category</label>
                        <Select
                            id="parentBrand"
                            options={parentBrandOptions}
                            value={parentBrand}
                            onChange={setParentBrand}
                            placeholder="Select category"
                        />
                    </div>

                    {/* Position */}
                    {/* <div className="oms-form-group">
                        <label htmlFor="position" className="oms-form-label">Position</label>
                        <input
                            type="text"
                            id="position"
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            placeholder="Enter position"
                        />
                    </div> */}

                    {/* Status */}
                    {/* <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">Status</label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div> */}

                    {/* Image Selector Modal */}
                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={handleSelect}
                        multiple={false}
                        setImages={setImages}
                    />

                    {/* <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={handlePdfSelect}
                        multiple={false}
                        setImages={setImages}
                    /> */}

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button
                            type="submit"
                            disabled={load}
                            style={{
                                pointerEvents: load ? "none" : "auto",
                                opacity: load ? 0.6 : 1,
                                cursor: load ? "not-allowed" : "pointer",
                            }}
                        >
                            {load
                                ? isEdit
                                    ? "Updating..."
                                    : "Submitting..."
                                : isEdit
                                    ? "Update"
                                    : "Submit"}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default CatlogModal;
